export default {
  wrapper: {
    flexDirection: 'row-reverse'
  },
  text: {
    textAlign: 'right',
    marginRight: '20px'
  }
};
